import { useEffect, useState } from 'react';

interface UseDebounceResult<T> {
    debouncedValue: T;
    isWaitingForFirstDebouncedValue: boolean;
}

export function useDebounce<T>(value: T, delayMiliseconds: number = 400): UseDebounceResult<T> {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const [isWaitingForFirstDebouncedValue, setIsWaitingForFirstDebouncedValue] = useState(false);

    useEffect(
        function setValueAfterTimeout() {
            if (!debouncedValue) {
                setIsWaitingForFirstDebouncedValue(true);
            }
            const handler = setTimeout(() => {
                setDebouncedValue(value);
                setIsWaitingForFirstDebouncedValue(false);
            }, delayMiliseconds);

            return () => clearTimeout(handler);
        },
        [value, delayMiliseconds]
    );

    return { debouncedValue, isWaitingForFirstDebouncedValue };
}
